module.exports = __webpack_public_path__ + "static/media/quoteW2PWhy.88ff84a0.md";